/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Microsoft_Calendar_Events_SuccessInputs */

const es_tools_microsoft_calendar_events_success = /** @type {(inputs: Tools_Microsoft_Calendar_Events_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de Microsoft obtenidos`)
};

const en_tools_microsoft_calendar_events_success = /** @type {(inputs: Tools_Microsoft_Calendar_Events_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft events fetched`)
};

/**
* | output |
* | --- |
* | "Microsoft events fetched" |
*
* @param {Tools_Microsoft_Calendar_Events_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_microsoft_calendar_events_success = /** @type {((inputs?: Tools_Microsoft_Calendar_Events_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Microsoft_Calendar_Events_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_microsoft_calendar_events_success(inputs)
	return en_tools_microsoft_calendar_events_success(inputs)
});
export { tools_microsoft_calendar_events_success as "tools.microsoft_calendar.events_success" }